import React from 'react';

export default function ChooseLocationStep({animating, locations, needContactHelp, chosenLocation, handleLocationChange, handleNextStep}) {

    return (
        <div className={"container mx-auto px-4 lg:px-8"}>
            <div className={"grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6"}>
                <div className={"lg:col-span-8 lg:col-start-3"}>
                    <h2>
                        Good news! We may be able to help.
                    </h2>
                    {needContactHelp ? (
                        <>
                            <p>
                                While we don’t have a dedicated franchise in your area, one of our nearby locations may
                                be able to answer your questions!
                            </p>
                            <p>
                                <strong>Choose the location nearest you.</strong>
                            </p>
                        </>
                    ) : (
                        <>
                            <p>
                                While we don’t have a dedicated franchise in your area, one of our nearby locations may
                                be able to deliver a Residential Friendly Dumpster to you!
                            </p>
                            <p>
                                <strong>Choose the location nearest you</strong>, fill in your request, and they will reach out to confirm if they can deliver to your area. We’re here to make your cleanup simple and hassle-free!
                            </p>
                        </>
                    )}
                </div>
                <div className={"lg:col-span-8 grid grid-cols-subgrid gap-x-8 gap-y-5 lg:col-start-3"}>
                    {locations.map(location => (
                        <div className={"lg:col-span-4 radio-option"} key={location.id}>
                            <input
                                type="radio"
                                name={"location"}
                                id={`location-${location.id}`}
                                value={location.id}
                                className={"peer"}
                                onChange={() => handleLocationChange(location)}
                            />
                            <label htmlFor={`location-${location.id}`} className={"check peer-checked:bg-brand-green-light"}>
                                {location.location_name}
                            </label>
                        </div>
                    ))}
                </div>
                <div className={"lg:col-span-8 lg:col-start-3"}>
                    <button className={"btn"} disabled={animating || chosenLocation === null} onClick={handleNextStep}>
                        {!needContactHelp ? 'Next Step →' : 'Get in touch'}
                    </button>
                </div>
            </div>
        </div>

    )
}